export default __webpack_public_path__ + "static/media/matchboard.1fd955a0.png";